import { render } from "./TestReportAOV2.vue?vue&type=template&id=04a83d30&scoped=true&ts=true"
import script from "./TestReportAOV2.vue?vue&type=script&lang=ts"
export * from "./TestReportAOV2.vue?vue&type=script&lang=ts"

import "./TestReportAOV2.vue?vue&type=style&index=0&id=04a83d30&scoped=true&lang=css"
import "./TestReportAOV2.vue?vue&type=style&index=1&id=04a83d30&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04a83d30"]])

export default __exports__